import { Customers, CustomerDetails } from '../../../../application/screens/Private';
import { MenuItem } from '../../../../lib/phinxapp/profiles/types';

export const routes: MenuItem[] = [
  {
    key: 'customers',
    basePath: '/',
    target: {
      component: Customers,
      path: '/customers',
    },
    enabled: true,
    icon: 'List',
    text: 'Listado de Clientes',
    children: [],
    default: true,
  },
  {
    key: 'customer-details',
    basePath: '/',
    target: {
      component: CustomerDetails,
      path: '/customers/:id',
    },
    enabled: true,
    icon: 'List',
    text: 'Información',
    children: [],
    default: false,
  },
];
